module.exports = __webpack_public_path__ + "img/classroom_digital.ba895741.png";